import { toLocalDateTime } from '../../../shared/i18n/date-time/LocalDateTime';

export function getTimeIn24HourFormat(date: Date) {
	const {
		time: { hours, minutes },
	} = toLocalDateTime(date);

	const paddedHours = String(hours).padStart(2, '0');
	const paddedMinutes = String(minutes).padStart(2, '0');

	return `${paddedHours}:${paddedMinutes}`;
}
